import {Component, OnDestroy, OnInit} from '@angular/core';
import {aggregateBy, process, State} from '@progress/kendo-data-query';
import {ExcelExportEvent, GridDataResult} from '@progress/kendo-angular-grid';
import {OrderReviewItem} from '~/app/core/common/models/OrderReviewItem';
import {StoreListService} from '~/app/core/common/services/store-list.service';
import {ReportColumnTitles} from '~/app/core/common/models/ReportColumnTitles';
import {ReportService} from '~/app/core/common/services/report.service';
import {ApplicationSettingsHelper} from '~/app/shared/helpers/application-settings-helper';
import {formatDate} from '@angular/common';
import {Store} from '~/app/core/common/models/store';
import {LoadingIndicatorHelper} from '~/app/shared/helpers/loading-indicator-helper';
import {ScheduleService} from '~/app/core/common/services/schedule.service';
import {WorkbookSheetRow} from '@progress/kendo-ooxml';
import {ExcelExportData} from '@progress/kendo-angular-excel-export';
import {DialogHelperComponent} from '~/app/shared/helpers/dialog-helper';
import {Router} from '@angular/router';
import {OrderService} from "~/app/core/common/services/order.service";
import {fileExcelIcon, filePdfIcon, SVGIcon} from "@progress/kendo-svg-icons";
@Component({
    selector: 'app-order-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent implements OnInit, OnDestroy {
    public columns = ReportColumnTitles.ORDER_REVIEW_PLACED_REPORT_COLUMNS;
    dateToday = '';
    public state: State = {};
    public gridData: GridDataResult = undefined;
    public totalPrice = 0;
    public trackingID: string;
    public orderItems: OrderReviewItem[] = [];
    confirmationColumns: any;
    confirmationMessages: GridDataResult;
    confirmationMessagesEnabled = false;
    orderStatus: number;
    store: Store;
    sum: number;
    public filePdfIcon: SVGIcon = filePdfIcon;
    public fileExcelIcon: SVGIcon = fileExcelIcon;

    public datedelivery: string;

    constructor(private _reportService: ReportService,
                private storeListService: StoreListService,
                public applicationSettings: ApplicationSettingsHelper,
                public dialogHelper: DialogHelperComponent,
                private _loadingIndicatorHelper: LoadingIndicatorHelper,
                public scheduleservice: ScheduleService,
                public router: Router,
    ) {
        this.exportMainGrid = this.exportMainGrid.bind(this);
    }

    async ngOnInit() {

        const stringEvent = this.applicationSettings.getEvent();
        const event = JSON.parse(stringEvent);
        const trackingId = event.trackingId;

        // tslint:disable-next-line:triple-equals
        if (stringEvent == '' || trackingId < 1) {
            this.applicationSettings.setEvent('');
            this.applicationSettings.setTrackingId('');
            this.router.navigateByUrl('/home');
            return;
        }


        this._loadingIndicatorHelper.show('');
        this.store = this.storeListService.pickedStore;
        this.dateToday = this.scheduleservice.dateParser(event.deliveryDateFormatted);
        this.datedelivery = this.scheduleservice.dateParser(event.callDateFormatted);

        this.orderStatus = +this.applicationSettings.getEventStatus();
        // TODO Get order number instead of tracking number
        this.trackingID = trackingId;
        if (this.orderStatus < 4) {
            this._reportService.getOrderReviewReport(this.trackingID).toPromise()
                .then((value) => {
                    this.orderItems = value;
                    this.sumItem();
                    this.gridData = process(this.orderItems, this.state);
                    this.confirmationMessagesEnabled = false;
                    this.sum = this.sumItemGroups('quantity', 1);

                });
            this._loadingIndicatorHelper.hide();
        } else {
            // @ts-ignore
            this.columns = ReportColumnTitles.ORDER_REVIEW_SHIP_CONFIRM_REPORT_COLUMNS;
            this._reportService.getOrderShipAndConfirmReport(this.trackingID, String(this.storeListService.pickedCustomerId)).toPromise()
                .then((value) => {
                    this.orderItems = value;
                    this.sumItem();
                    this.gridData = process(this.orderItems, this.state);
                    this.sum = this.sumItemGroups('confirmedQuantity', 1);
                });
            this.confirmationColumns = ReportColumnTitles.ORDER_REVIEW_CONFIRMED_CONFIRMATION_MESSAGES;
            this._reportService.getOrderConfirmItemReport(this.trackingID).toPromise().then((result) => {
                if (result.length > 0) {
                    this.confirmationMessagesEnabled = true;
                    this.confirmationMessages = process(result, this.state);
                    this.totalPrice = 30;
                }
            });
            this._loadingIndicatorHelper.hide();
        }
    }


    public exportMainGrid(): ExcelExportData {
        const items = this.gridData as any;
        const dataItems = items.data;
        return {
            data: process(dataItems, {}).data,
        };
    }

    sumItemGroups(field: string, griddata: number) {
        if (this.gridData === undefined) {
            return;
        }
        let data: any[];
        if (griddata === 1) {
            data = this.gridData.data;
        } else {
            data = this.confirmationMessages.data;
        }
        const aggregateResult = aggregateBy(data, [{aggregate: 'sum', field: field}]);
        if (aggregateResult[field] !== undefined) {
            return aggregateResult[field].sum;
        } else {
            return 0;
        }
    }

    public exportAllData(): ExcelExportData {
        const items = this.gridData as any;
        const dataItems = items.data;
        return {
            data: process(dataItems, {}).data,
        };
    }

    sumItem() {
        const numbers = this.orderItems.map(i => i.totalCost);
        this.totalPrice = numbers.reduce((a, b) => a + b, 0);
    }

    dateParser(dateStr: string): string {
        // 2019.11.5 08:45 (24hr); - converting valid date format like this
        const date = dateStr.substring(0, 10);
        const time = dateStr.substring(11, 16);
        const convertDate = date.replace('.', '/').replace('.', '/');
        const validDate = new Date(convertDate + ' ' + time + ':00');

        return formatDate(validDate, 'mediumDate', 'en-US');
    }

    excelEmptyRow() {
        return {} as WorkbookSheetRow;
    }

    buildExcelDocumentHeader() {
        const header = [];
        const sourcelink = <WorkbookSheetRow>{};
        const orderreview = <WorkbookSheetRow>{};
        const orderSubmitted = <WorkbookSheetRow>{};
        const store = <WorkbookSheetRow>{};
        const address = <WorkbookSheetRow>{};
        const statecity = <WorkbookSheetRow>{};


        sourcelink.cells = [{}, {}, {}, {}, {}, {},
            {value: 'SourceLink'}
        ];
        header.unshift(sourcelink);
        orderreview.cells = [{}, {}, {}, {}, {}, {},
            {value: `Order Review - ${this.dateToday} `}
        ];
        header.unshift(orderreview);
        orderSubmitted.cells = [{}, {}, {}, {}, {}, {},
            {value: `Order Submitted - ${this.datedelivery}`}
        ];
        header.unshift(orderSubmitted);
        if (this.store !== undefined) {
            store.cells = [{}, {}, {}, {}, {}, {},
                {value: `Store #${this.store.customerId} - ${this.store.identity}`}
            ];
            header.unshift(store);
            address.cells = [{}, {}, {}, {}, {}, {},
                {value: `${this.store.address}`}
            ];
            header.unshift(address);
            statecity.cells = [{}, {}, {}, {}, {}, {},
                {value: `${this.store.city}, ${this.store.state} ${this.store.zip}`}
            ];
        }
        header.unshift(statecity);
        header.unshift(this.excelEmptyRow());
        return header;
    }

    excelExported($event: ExcelExportEvent) {
        // Let's the grid handle the main table creation, I add confirmations if needed.
        try {
            const sheet = $event.workbook.sheets[0];
            sheet.rows.forEach((tabler: WorkbookSheetRow) => {
                tabler.cells[6].format = '#,##0.00';
                tabler.cells[3].format = '#,##0.00';
            });
            sheet.rows.unshift({});
            sheet.freezePane.rowSplit = 0;
            if (this.confirmationMessagesEnabled) {
                const confirmRow = [];
                const reportHeader = <WorkbookSheetRow>{
                    cells: [
                        {colSpan: 7, value: 'Confirmation Messages', textAlign: 'center'}
                    ]
                };
                confirmRow.unshift(reportHeader);
                confirmRow.unshift(this.excelEmptyRow());
                confirmRow.unshift(this.buildConfirmGridHeader());
                this.buildConfirmData().forEach((row) => {
                    confirmRow.unshift(row);
                });

                const messageHeader = <WorkbookSheetRow>{
                    cells: [
                        {colSpan: 7, value: 'Order Review', textAlign: 'center'}
                    ]
                };
                confirmRow.unshift(messageHeader);
                confirmRow.forEach((item) => {
                    sheet.rows.unshift(item);
                });
                sheet.rows.push({});
            } else {
                const messageHeader = <WorkbookSheetRow>{
                    cells: [
                        {colSpan: 7, value: 'Order Review', textAlign: 'center'}
                    ]
                };
                sheet.rows.unshift(messageHeader);
            }


            this.buildExcelDocumentHeader().forEach((item) => {
                sheet.rows.unshift(item);
            });
            sheet.name = 'Order Review';
        } catch (error) {
            this.dialogHelper.showOkErrorDialog('Excel Export Error',
                'There was a problem exporting your data to excel, Please try again later.').then(r => {
            });
            console.error(error);
        }
    }

    buildConfirmGridHeader() {
        return <WorkbookSheetRow>{
            cells: [
                {value: 'Item No', background: '#6F6F6F', color: '#ffffff'},
                {value: 'Description', background: '#6F6F6F', color: '#ffffff'},
                {value: 'Reason', background: '#6F6F6F', color: '#ffffff'},
                {value: 'Suggested Qty', background: '#6F6F6F', color: '#ffffff'},
                {value: 'Confirmed Quantity', background: '#6F6F6F', color: '#ffffff', colSpan: 3},
            ]
        };
    }

    buildConfirmData() {
        const workbookRows = new Array<WorkbookSheetRow>();
        this.confirmationMessages.data.forEach((item) => {
            const row = <WorkbookSheetRow>{};
            row.cells = [
                {value: item.itemNo},
                {value: item.description},
                {value: item.reason},
                {value: item.qtySuggested},
                {value: item.qtyConfirmed},
            ];
            workbookRows.push(row);
        });
        return workbookRows;
    }

    exportToExcel(confirmGrid: any) {
        if (this.gridData == null) {
            return;
        }
        try {
            setTimeout(() => {
                confirmGrid.saveAsExcel();
            }, 100);
        } catch (ex) {

        }
    }

    ngOnDestroy(): void {
        this.applicationSettings.setEvent('');
        this.applicationSettings.setTrackingId('');
    }
}
